import { getMeasurementQty } from "../Components/Shared/PriceBreakdown";

function scopeMatchesBundle(scope, bundleId) {
  if (!scope) return true;
  return Array.isArray(scope.bundleIds) && bundleId != null && scope.bundleIds.includes(bundleId);
}

function findBundle(allPriceBundles, bundleId) {
  for (const company of allPriceBundles) {
    const found = (company.priceBundles || []).find((b) => b.id === bundleId);
    if (found) return found;
  }
  return null;
}

export function calculateProjection(measurement, projection, allPriceBundles) {
  if (projection?.allocation) return null;

  if (projection?.substitutions?.length > 0) {
    if (!measurement.priceBundleId) return measurement.eventPrice;
    const bundle = findBundle(allPriceBundles, measurement.priceBundleId);
    if (!bundle || !bundle.items?.length) return measurement.eventPrice;
    const qty = getMeasurementQty(measurement);
    const originalTotal = bundle.items.reduce((s, i) => s + i.price * i.multiplier * (i.isFixed ? 1 : qty), 0);
    const projectedTotal = bundle.items.reduce((s, i) => {
      const sub = projection.substitutions.find(
        (su) => su.originalPriceDefinitionId === i.priceDefinitionId && scopeMatchesBundle(su.scope, measurement.priceBundleId)
      );
      return s + (sub ? sub.newPrice : i.price) * i.multiplier * (i.isFixed ? 1 : qty);
    }, 0);
    return originalTotal > 0 ? measurement.eventPrice * (projectedTotal / originalTotal) : measurement.eventPrice;
  }

  if (projection?.priceDefinitions?.length > 0) {
    if (!measurement.priceBundleId) return measurement.eventPrice;
    const bundle = findBundle(allPriceBundles, measurement.priceBundleId);
    if (!bundle || !bundle.items?.length) return measurement.eventPrice;
    const qty = getMeasurementQty(measurement);
    const originalTotal = bundle.items.reduce((s, i) => s + i.price * i.multiplier * (i.isFixed ? 1 : qty), 0);
    const projectedTotal = bundle.items.reduce((s, i) => {
      const pd = projection.priceDefinitions.find((p) => p.priceDefinitionId === i.priceDefinitionId);
      return s + (pd ? pd.newPrice : i.price) * i.multiplier * (i.isFixed ? 1 : qty);
    }, 0);
    return originalTotal > 0 ? measurement.eventPrice * (projectedTotal / originalTotal) : measurement.eventPrice;
  }

  if (projection?.composition) {
    if (!measurement.priceBundleId) return measurement.eventPrice;
    const recipe = projection.composition[measurement.priceBundleId];
    if (!recipe) return measurement.eventPrice; // bundle not modified by this scenario
    const bundle = findBundle(allPriceBundles, measurement.priceBundleId);
    if (!bundle || !bundle.items?.length) return measurement.eventPrice;
    const qty = getMeasurementQty(measurement);
    const originalTotal = bundle.items.reduce((s, i) => s + i.price * i.multiplier * (i.isFixed ? 1 : qty), 0);
    const projectedTotal = recipe.reduce((s, r) => {
      if (r.price == null) return s; // unpriced added definition contributes nothing
      return s + r.price * Number(r.multiplier) * (r.isFixed ? 1 : qty);
    }, 0);
    return originalTotal > 0 ? measurement.eventPrice * (projectedTotal / originalTotal) : measurement.eventPrice;
  }

  if (projection?.accounts?.length > 0) {
    const acc = projection.accounts.find((a) => a.id === measurement.accountId);
    return acc ? (measurement.eventPrice * acc.percentage) / 100 : measurement.eventPrice;
  }

  return measurement.eventPrice;
}
